export default class ComplaintsFiltersViewModel {
    isActive: boolean = false;
    complaint: string[] = [];
    complaintCategory: string[] = [];
}